var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","top":"0","bottom":"0","width":"100%"}},[_c('div',{ref:"render",staticClass:"fillParent"})])}
var staticRenderFns = []

export { render, staticRenderFns }